<template>
  <div>
    <v-banner color="teal lighten-4">
      <div class="title">{{ "lng_extra_house_box_txt" | translate }}</div>
      <template v-slot:actions>
        <v-btn small color="#0B7894" dark @click="$emit('addNewHouseBox', systemId)">
          {{ "lng_add_extra_box_btn" | translate }}</v-btn>
      </template>
    </v-banner>
    <table v-if="findBoxes" class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>{{ "lng_th_boxType" | translate }}</th>
          <th>{{ "lng_th_boxId" | translate }}</th>
          <th>{{ "lng_th_boxPass" | translate }}</th>
          <th>{{ "lng_th_actions" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="houseBoxes.boxes && houseBoxes.boxes.length" v-for="items in houseBoxes.boxes">
          <td>{{ "lng_house_text" | translate }}</td>
          <td>{{ items.deviceid }}</td>
          <td>{{items.pincode}}</td>
          <td>
            <v-btn small color="#0B7894" dark @click="deleteHouseBox(items.deviceid)">
              {{ "lng_delete_btn" | translate }}</v-btn>
          </td>
        </tr>

      </tbody>
    </table>
    <Alert v-if="alertToggle" :message-data="flashMessageData" :alert-toggle="alertToggle"
      @alertToggleUpdate="alertToggle = false" />
  </div>
</template>
    
<script>
import UserService from "../services/user-service";
import GlobalService from "../services/global-service";
import { translateFunc } from '../common/Filters';
import Alert from "../components/Alert"

export default {
  name: "ExtraBoxesModal",
  components: {
    Alert
  },
  data() {
    return {
      houseBoxes: [],
      showLoading: false,
      error: "",
      alertToggle: false,
      flashMessageData: {},
    };
  },
  props: {
    extraHouseBoxes: {
      type: Array,
      default: () => []
    },
    systemId: {
      type: String,
      default: ""
    },
    userToken: {
      type: String,
      default: ""
    }
  },
  // watch: {
  //   extraHouseBoxes: function (newVal) {
  //     this.houseBoxes = newVal;
  //     console.log("------this.houseBoxes: ", this.houseBoxes);
  //   },
  // },
  mounted() {
    this.findBoxes();

  },
  computed: {

  },
  methods: {
    findBoxes() {
      const data = this.extraHouseBoxes && this.extraHouseBoxes.find(e => e.id == this.systemId);
      this.houseBoxes = data;
      return data && data.id
    },
    async deleteHouseBox(houseboxId) {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        response = await GlobalService.deleteExtraHouseBox(this.userToken, this.systemId, houseboxId);
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        this.showAlert({ msg: translateFunc("lng_try_again_txt"), status: 1 });
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        this.$emit("refreshHouseBoxes", this.systemId);
        this.showAlert(response);
      } else {
        this.showLoading = false;
        this.error = response.msg;
        this.showAlert(response);
      }
    },
    showAlert(res) {
      this.flashMessageData = res;
      this.alertToggle = true;
    }
  }
};
</script>    